import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { formatText } from '../../helpers/value'
import classes from '../index.module.scss'

const ItemsInformation = ({ data, style }) => {
  return (
    <div className={`dFlex ${classes.itemData}`}>
      <div className={classes.column1} />
      {data.map(({ title, value }, index) => {
        return (
          <Element
            style={{
              paddingLeft: index ? 24 : 0,
              paddingRight: index !== data.length - 1 ? 24 : 0,
              borderLeft: index ? '1px solid #D5D5D5' : undefined,
              ...style,
            }}
            className="dFlex"
            key={index}
          >
            <div className="fw600">{<Translate value={title} />}:&nbsp;</div>
            <div>{formatText(value)}</div>
          </Element>
        )
      })}
    </div>
  )
}

ItemsInformation.propTypes = {
  data: PropTypes.array,
  style: PropTypes.object,
}

ItemsInformation.defaultProps = {
  data: [],
  style: {},
}

export default ItemsInformation
